import React, { useState, useEffect } from "react";
import "./userManipulation.css";
import Modal from "../../../components/Modal";
import InputField from "../../../components/InputField";
import { sendResetPasswordEmail } from "../../../../services/api/users";
import { RiAiGenerate2 } from "react-icons/ri";
import { Dropdown } from "semantic-ui-react";

const initialFormState = {
  id: null,
  full_name: "",
  document: "",
  email: "",
  entityType: "user",
  position: "",
  password: "",
  real_estate: "",
  type: "",
};

export default function UserManipulation({
  pageType, // A prop pageType é usada aqui
  newUser,
  user,
  onAddUser,
  onEditUser,
  openModal,
  setOpenModal,
  imobiliariaVinculos = [],
}) {
  const [formState, setFormState] = useState(initialFormState);
  const [errors, setErrors] = useState({ document: "", email: "" });
  const [resetEmailSent, setResetEmailSent] = useState(false);

  // MODIFICAÇÃO APLICADA AQUI
  useEffect(() => {
    if (openModal) {
      if (newUser || !user) {
        // Se for um novo cadastro e a página for de 'real_estate'
        if (pageType === "real_estate") {
          setFormState({
            ...initialFormState,
            position: "real_estates", // Define o valor padrão para o select
            entityType: "real_estate", // Define o tipo de entidade
          });
        } else {
          // Comportamento padrão para outros tipos de página
          setFormState({ ...initialFormState, entityType: "user" });
        }
      } else {
        // Lógica para editar um usuário existente (permanece a mesma)
        setFormState({
          id: user.id,
          full_name: user.full_name || user.displayName || "",
          document: user.document || user.displayDocument || "",
          email: user.email || "",
          entityType: user.entityType || "user",
          position: user.position || "",
          real_estate: user.real_estate_id || user.real_estate || "",
          password: "",
        });
      }
      setErrors({ document: "", email: "" });
      setResetEmailSent(false);
    }
  }, [openModal, newUser, user, pageType]); // Adicionado pageType às dependências

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name === "position") {
      if (value === "real_estates") {
        setFormState((prevState) => ({
          ...prevState,
          position: value,
          entityType: "real_estate",
          document: "",
          email: "",
        }));
      } else {
        setFormState((prevState) => ({
          ...prevState,
          position: value,
          entityType: "user",
        }));
      }
    } else {
      setFormState((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }

    if (name === "document" && errors.document)
      setErrors((e) => ({ ...e, document: "" }));
    if (name === "email" && errors.email)
      setErrors((e) => ({ ...e, email: "" }));
  };

  const handleDropdownChange = (e, { name, value }) => {
    setFormState((prevState) => ({ ...prevState, [name]: value }));
  };

  const imobiliariaOptions = imobiliariaVinculos.map((item) => ({
    key: `imob-${item.id}`,
    value: item.id,
    text: item.displayName || item.full_name || item.name,
  }));

  const handleInputChangeEmail = (event) => {
    const { value } = event.target;
    setFormState((prevState) => ({ ...prevState, email: value }));
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value) && value.length > 0) {
      setErrors((prevState) => ({ ...prevState, email: "E-MAIL INVÁLIDO." }));
    } else {
      setErrors((prevState) => ({ ...prevState, email: "" }));
    }
  };

  const handleInputChangeCpfCnpj = (event) => {
    let value = event.target.value.replace(/\D/g, "");
    setFormState((prevState) => ({ ...prevState, document: value }));
    if (value.length > 0 && value.length !== 11 && value.length !== 14) {
      setErrors((prevState) => ({
        ...prevState,
        document: "CPF/CNPJ DEVE TER 11 OU 14 NÚMEROS.",
      }));
    } else {
      setErrors((prevState) => ({ ...prevState, document: "" }));
    }
  };

  const generatePassword = () => {
    const chars =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let newPassword = "";
    for (let i = 0; i < 8; i++) {
      newPassword += chars[Math.floor(Math.random() * chars.length)];
    }
    setFormState((prevState) => ({ ...prevState, password: newPassword }));
  };

  const isFormValid = () => {
    const { full_name, document, email, position, password, entityType } =
      formState;

    if (entityType === "real_estate") {
      return full_name.trim() !== "";
    }

    if (
      !full_name.trim() ||
      !document.trim() ||
      !email.trim() ||
      !position
    ) {
      return false;
    }

    if (newUser && !password.trim()) {
      return false;
    }

    return !errors.document && !errors.email;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!isFormValid()) {
      alert(
        "Preencha todos os campos obrigatórios corretamente e verifique as mensagens de erro.",
      );
      return;
    }
    let success = newUser
      ? await onAddUser(formState)
      : await onEditUser(formState);
    if (success) {
      setOpenModal(false);
    }
  };

  const handleSendPasswordResetEmail = async () => {
    if (!formState.email || errors.email) {
      alert("Por favor, informe um e-mail válido para o usuário.");
      return;
    }
    setResetEmailSent(true);
    try {
      await sendResetPasswordEmail(formState.email);
    } catch (error) {
      if (error.status === 429) {
        alert("Muitas tentativas de redefinição. Aguarde um momento e tente novamente.");
      } else {
        alert("Erro ao enviar e-mail de redefinição.");
      }
      console.error("Erro ao enviar e-mail de redefinição:", error);
    }
    setTimeout(() => setResetEmailSent(false), 20000);
  };

  return (
    <Modal
      isOpen={openModal}
      title={
        pageType === "real_estate"
          ? "Cadastro de Entidade"
          : `Editar ${formState.entityType === "user" ? "Usuário" : "Imobiliária"}`
      }
      otherClassModalInterface="modal-interface-user-controll"
      onClose={() => setOpenModal(false)}
    >
      <form onSubmit={handleSubmit}>
        <InputField
          className="fields-new-user"
          ident={
            formState.entityType === "user"
              ? "Nome do Usuário"
              : "Nome da Entidade"
          }
          fieldRequired={true}
          type="text"
          value={formState.full_name}
          name="full_name"
          onChange={handleInputChange}
          placeholder={
            formState.entityType === "user"
              ? "Nome completo do usuário"
              : "Insira o nome da imobiliária, construtora, etc."
          }
          required
        />

        {pageType === "real_estate" && (
          <div className="fields-new-user">
            <label>
              Categoria<span style={{ color: "red" }}>*</span>
            </label>
            <select
              name="type"
              required
              value={formState.type}
              onChange={handleInputChange}
            >
              <option value="">Selecione a Categoria</option>
              <option value="Construtora">Construtora</option>
              <option value="Investidor">Investidor</option>
              <option value="Imobiliária">Imobiliária</option>
            </select>
          </div>
        )}

        {formState.entityType === "user" && (
          <InputField
            className="fields-new-user"
            ident="CPF/CNPJ"
            type="text"
            value={formState.document}
            name="document"
            onChange={handleInputChangeCpfCnpj}
            placeholder="Somente números"
            maxLength={14}
            minLength={11}
            fieldRequired={true}
            required
          />
        )}

        {errors.document && (
          <p className="error-message-user">{errors.document}</p>
        )}

        {formState.entityType === "user" && (
          <>
            <InputField
              className="fields-new-user"
              ident="E-mail"
              fieldRequired={true}
              type="email"
              value={formState.email}
              name="email"
              onChange={handleInputChangeEmail}
              placeholder="Digite o e-mail"
              required
            />
            {errors.email && (
              <p className="error-message-user">{errors.email}</p>
            )}
          </>
        )}

        {formState.entityType === "user" && formState.position === "common" && (
          <div className="input-space-default fields-new-user">
            <label>Vínculo com Imobiliária</label>
            <Dropdown
              placeholder="Digite ou selecione o nome da Imobiliária"
              fluid
              search
              selection
              clearable
              name="real_estate"
              options={imobiliariaOptions}
              value={formState.real_estate}
              onChange={handleDropdownChange}
              disabled={!imobiliariaVinculos?.length}
              noResultsMessage="Nenhuma imobiliária encontrada."
            />
          </div>
        )}

        {formState.entityType === "user" && (
          <div className="fields-new-user">
            <label>
              Nível de Acesso<span style={{ color: "red" }}>*</span>
            </label>
            <select
              name="position"
              required
              value={formState.position}
              onChange={handleInputChange}
            >
              <option value="">Selecione o Nível</option>
              <option value="admin">Admin</option>
              <option value="assistant">Assistente</option>
              <option value="common">Corretor Imobiliário</option>
              <option value="real_estates">Entidade Responsável</option>
            </select>
          </div>
        )}

        {formState.entityType === "user" &&
          (newUser ? (
            <div className="password-container fields-new-user">
              <InputField
                ident="Senha"
                fieldRequired={true}
                type="text"
                value={formState.password}
                name="password"
                onChange={handleInputChange}
                placeholder="Digite ou gere uma senha"
                required
              />
              <button
                type="button"
                className="bt-generate-pass"
                onClick={generatePassword}
                title="Gerar Senha"
              >
                <i>
                  <RiAiGenerate2 />
                </i>
              </button>
            </div>
          ) : (
            <div className="resend-password-container fields-new-user">
              <label>Redefinição de Senha: </label>
              <button
                type="button"
                className={`send-reset-btn ${resetEmailSent ? "sent" : ""}`}
                onClick={handleSendPasswordResetEmail}
                disabled={
                  !formState.email || resetEmailSent || errors.email !== ""
                }
              >
                {resetEmailSent
                  ? "E-MAIL DE REDEFINIÇÃO ENVIADO"
                  : "ENVIAR E-MAIL DE REDEFINIÇÃO"}
              </button>
            </div>
          ))}

        <button
          className="bt-confirm"
          type="submit"
          style={{
            backgroundColor: isFormValid() ? "var(--principal-color)" : "#ccc",
            cursor: isFormValid() ? "pointer" : "not-allowed",
          }}
        >
          {newUser ? "Adicionar" : "Atualizar"}
        </button>
      </form>
    </Modal>
  );
}
